import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

// ✅ NEW: Get paginated products with filters and sorting
export const getProductsPaginated = async ({
  pageNumber = 1,
  pageSize = 10,
  searchTerm = null,
  categoryId = null,
  brandId = null,
  supplierId = null,
  stockStatus = null,
  sortBy = 'Name',
  sortDirection = 'Asc',
  suppressErrorToast = false
} = {}) => {
  const params = {
    pageNumber,
    pageSize,
    sortBy,
    sortDirection
  };

  // Only add optional params if they have values
  if (searchTerm) params.searchTerm = searchTerm;
  if (categoryId) params.categoryId = categoryId;
  if (brandId) params.brandId = brandId;
  if (supplierId) params.supplierId = supplierId;
  if (stockStatus) params.stockStatus = stockStatus;

  const response = await axiosInstance.get('Product/paginated', { params, suppressErrorToast });
  return response.data;
};

// ✅ Keep old method for backward compatibility
export const getProducts = async () => {
  const response = await axiosInstance.get('Product/get-products');
  return response.data;
};

export const getProductById = async (id, config = {}) => {
  const response = await axiosInstance.get(`Product/get-product/${id}`, config);
  return response.data;
};

export const addProduct = async (product, config = {}) => {
 
  const res = await axiosInstance.post('product/add-product', product, config);
  return res.data;
};

export const updateProduct = async (product, config = {}) => {
 
  const response = await axiosInstance.post('product/update-product', product, config);
  return response.data;
};

export const deleteProduct = async (id, config = {}) => {
  await axiosInstance.delete(`Product/delete-product/${id}`, config);
};

export const searchProducts = async (paramsObj) => {
  const response = await axiosInstance.get('product/search', { 
    params: paramsObj,
    suppressErrorToast: true 
  });
  return response.data;
};

// ✅ NEW: Search product by SKU or Barcode for public product lookup
export const searchBySKUOrBarcode = async (search) => {
  const response = await axiosInstance.get('Product/search-by-sku-barcode', {
    params: { search },
    suppressErrorToast: true
  });
  return response.data;
};

export const downloadTemplate = async (config = {}) => {
  const response = await axiosInstance.get('Product/import/template', {
    responseType: 'blob',
    ...config
  });
  return response.data;
};

export const exportProducts = async (includeInventory = false, config = {}) => {
  const response = await axiosInstance.get('Product/export', {
    params: { includeInventory },
    responseType: 'blob',
    ...config
  });
  return response.data;
};

export const validateImportFile = async (file, config = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axiosInstance.post('Product/import/validate', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 300000,
    ...config
  });
  return response.data;
};

export const importProducts = async (file, config = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axiosInstance.post('Product/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 300000,
    ...config
  });
  return response.data;
};

// ✅ NEW: Get all categories with products (first page of products for each category)
export const getCategoriesWithProducts = async (pageSize = 10) => {
  const response = await axiosInstance.get('Product/categories-with-products', {
    params: { pageSize }
  });
  return response.data;
};

// ✅ NEW: Get paginated products for a specific category
export const getCategoryProductsPaginated = async (categoryId, pageNumber = 1, pageSize = 10) => {
  const response = await axiosInstance.get(`Product/category/${categoryId}/products`, {
    params: { pageNumber, pageSize }
  });
  return response.data;
};

// ✅ Get categories with product count only (no products loaded)
export const getCategoriesWithProductCount = async () => {
  const response = await axiosInstance.get('Product/categories-with-product-count');
  return response.data;
};

// ✅ Get products by category with pagination
export const getProductsByCategory = async (categoryId, page = 1, pageSize = 10) => {
  const response = await axiosInstance.get('Product/getproductbycategory', {
    params: { categoryId, page, pageSize }
  });
  return response.data;
};

// ✅ NEW: Get products filtered by category and/or supplier
export const getProductsByFilters = async (categoryId = null, supplierId = null, brandId = null) => {
  const params = new URLSearchParams();
  if (categoryId) params.append('categoryId', categoryId);
  if (supplierId) params.append('supplierId', supplierId);
  if (brandId) params.append('brandId', brandId);
  
  const response = await axiosInstance.get(`Product/filter?${params.toString()}`);
  return response.data;
};

// ✅ Get purchase history for a product
export const getProductPurchaseHistory = async (productId) => {
  const response = await axiosInstance.get(`Product/${productId}/purchase-history`);
  return response.data;
};